module.exports = require('./helpers/bundle-url').getBundleURL('3whur') + "logo.c51670a8.svg";